import { HeroCarouselItemsContentProps } from '../hero-carousel'
import { getCustomStyles } from '../utils'

type Props = {
  content: HeroCarouselItemsContentProps
  textAlignment: CanvasTextAlign
}

export const PromoDate = (props: Props) => {
  const customStylesPromoDates = getCustomStyles(
    props.content?.promoDates?.styles
  )

  return props.content?.promoDates?.text ? (
    <div
      className="font-light text-[12px] sm:text-[14px]"
      style={{
        ...customStylesPromoDates,
        textAlign: props.textAlignment as CanvasTextAlign,
      }}
    >
      {props.content?.promoDates?.text}
    </div>
  ) : null
}
